import AxiosAPI from "./AxiosAPI";

export const fetchAllEmployees = async (storeId) => {
  try {
    const response = await AxiosAPI.get(`/staff/employees?storeId=${storeId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};


export const fetchEmployee = async (
  storeID,
  from,
  size,
  option,
  searchText = '',
  searchCity = '',
  searchState = '',
  searchCountry = '',
  searchPinCode = '',
  searchCustomField1 = '',
  searchCustomField2 = '',
  searchCustomField3 = '',
  searchCustomField4 = '',
  searchCustomField5 = '',
  searchCustomField6 = '',
  searchShowInSales = '',
  searchFirstName = '',
  searchLastName = '',
  searchPhoneNo = '',
  searchEmailID = '',
) => {
  try {
    let apiUrl = `/staff/employee`;
    let queryParams = [];



    if (from) {
      queryParams.push(`from=${from}`);
    }
    if (size) {
      queryParams.push(`size=${size}`);
    }




    // Add storeID if provided
    if (storeID) {
      queryParams.push(`storeID=${storeID}`);
    }

    if (searchFirstName) {
      queryParams.push(`searchFirstName=${searchFirstName}`);
    }
    if (searchLastName) {
      queryParams.push(`searchLastName=${searchLastName}`);
    }
    if (searchPhoneNo) {
      queryParams.push(`searchPhoneNo=${searchPhoneNo}`);
    }
    if (searchEmailID) {
      queryParams.push(`searchEmailID=${searchEmailID}`);
    }

    // Add option if provided
    if (option) {
      queryParams.push(`option=${option}`);
    }

    // Add search parameters if they exist
    if (searchText) {
      queryParams.push(`searchText=${searchText}`);
    }
    if (searchCity) {
      queryParams.push(`searchCity=${searchCity}`);
    }
    if (searchState) {
      queryParams.push(`searchState=${searchState}`);
    }
    if (searchCountry) {
      queryParams.push(`searchCountry=${searchCountry}`);
    }
    if (searchPinCode) {
      queryParams.push(`searchPinCode=${searchPinCode}`);
    }
    if (searchCustomField1) {
      queryParams.push(`searchCustomField1=${searchCustomField1}`);
    }
    if (searchCustomField2) {
      queryParams.push(`searchCustomField2=${searchCustomField2}`);
    }
    if (searchCustomField3) {
      queryParams.push(`searchCustomField3=${searchCustomField3}`);
    }
    if (searchCustomField4) {
      queryParams.push(`searchCustomField4=${searchCustomField4}`);
    }
    if (searchCustomField5) {
      queryParams.push(`searchCustomField5=${searchCustomField5}`);
    }
    if (searchCustomField6) {
      queryParams.push(`searchCustomField6=${searchCustomField6}`);
    }
    if (searchShowInSales) {
      queryParams.push(`searchShowInSales=${searchShowInSales}`);
    }

    apiUrl += queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    const response = await AxiosAPI.get(apiUrl);
    return response.data;
  } catch (err) {
    console.error('Error fetching staff:', err);
    throw err;
  }
};


export const handleAddEmployee = async (data) => {
  try {
    const response = await AxiosAPI.post(
      `/staff/employee`,
      data, {
      headers: {
        "Content-Type": "application/json",
      },
    }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const handleEditEmployee = async (data) => {
  console.log("data",data);
  try {
    const response = await AxiosAPI.put(
      `/staff/employee/${data.key}`,
      data, {
      headers: {
        "Content-Type": "application/json",
      },
    }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteEmployee = async (key) => {
  try {
    const response = await AxiosAPI.delete(
      `/staff/employee/${key}`
    );
    return response.data;
  } catch (err) {
    console.log(err);

  }
};

export const handleAddEmployeeService = async (data) => {
  try {
    const response = await AxiosAPI.post(
      `/staff/employee-services`,
      data, {
      headers: {
        "Content-Type": "application/json",
      },
    }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const handleEditEmployeeService = async (key,data) => {
  try {
    const response = await AxiosAPI.put(
      `/staff/employee-services/${key}`,
      data, {
      headers: {
        "Content-Type": "application/json",
      },
    }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};